const config = {
	timezone: "Asia/Singapore",
	apiURL: window.ENV.API_URL || "http://localhost:8003/api",
	ossUrl: window.ENV.OSS_URL || "https://img-sit.hotlink.cyou/public/",
	region: window.ENV.REGION || "minionpro7",
};

export default config;
